import Participant from "../../entities/participant";

/**
 * Participant actions
 *
 * Call order:
 *
 * PARTICIPANT_SAVE_QUEUE:	adds the item to the save queue
 * --> PARTICIPANT_SAVE:	modifies the state
 * --> PARTICIPANT_SAVE_SUCCESS: if all went well
 * --> PARTICIPANT_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail PARTICIPANT_SAVE_QUEUE is during the call to PARTICIPANT_SAVE,
 * as adding an item to the queue should never fail.
 */

export const PARTICIPANT_FETCH_ONE_QUEUE: any = 'PARTICIPANT_FETCH_ONE_QUEUE';
export const PARTICIPANT_FETCH_SUCCESS: any = 'PARTICIPANT_FETCH_SUCCESS';
export const PARTICIPANT_FETCH_FAILURE: any = 'PARTICIPANT_FETCH_FAILURE';
export const PARTICIPANT_FETCH_ONE_SUCCESS: any = 'PARTICIPANT_FETCH_ONE_SUCCESS';
export const PARTICIPANT_FETCH_ONE_FAILURE: any = 'PARTICIPANT_FETCH_ONE_FAILURE';

export const PARTICIPANT_SAVE: any = 'PARTICIPANT_SAVE';
export const PARTICIPANT_SAVE_QUEUE: any = 'PARTICIPANT_SAVE_QUEUE';
export const PARTICIPANT_SAVE_SUCCESS: any = 'PARTICIPANT_SAVE_SUCCESS';
export const PARTICIPANT_SAVE_FAILURE: any = 'PARTICIPANT_SAVE_FAILURE';

export const PARTICIPANT_SAVE_MANY: any = 'PARTICIPANT_SAVE_MANY';
export const PARTICIPANT_SAVE_MANY_QUEUE: any = 'PARTICIPANT_SAVE_MANY_QUEUE';
export const PARTICIPANT_SAVE_MANY_SUCCESS: any = 'PARTICIPANT_SAVE_MANY_SUCCESS';
export const PARTICIPANT_SAVE_MANY_FAILURE: any = 'PARTICIPANT_SAVE_MANY_FAILURE';

export const PARTICIPANT_REMOVE: any = 'PARTICIPANT_REMOVE';
export const PARTICIPANT_REMOVE_QUEUE: any = 'PARTICIPANT_REMOVE_QUEUE';
export const PARTICIPANT_REMOVE_SUCCESS: any = 'PARTICIPANT_REMOVE_SUCCESS';
export const PARTICIPANT_REMOVE_FAILURE: any = 'PARTICIPANT_REMOVE_FAILURE';

export const PARTICIPANT_RESTORE: any = 'PARTICIPANT_RESTORE';
export const PARTICIPANT_RESTORE_QUEUE: any = 'PARTICIPANT_RESTORE_QUEUE';
export const PARTICIPANT_RESTORE_SUCCESS: any = 'PARTICIPANT_RESTORE_SUCCESS';
export const PARTICIPANT_RESTORE_FAILURE: any = 'PARTICIPANT_RESTORE_FAILURE';

export const PARTICIPANT_RESTORE_MANY: any = 'PARTICIPANT_RESTORE_MANY';
export const PARTICIPANT_REMOVE_MANY: any = 'PARTICIPANT_REMOVE_MANY';

/* Fetch actions */
export const fetchParticipantSuccess = (participants: Participant[], partial: boolean, lastFetch: number) => ({type: PARTICIPANT_FETCH_SUCCESS, participants, partial, lastFetch});
export const fetchParticipantFailure = (err: any) => {
		console.error('ParticipantAction: fetchParticipantFailure', err);
		return {type: PARTICIPANT_FETCH_FAILURE, err};
};
export const fetchOneParticipantQueue = (participantId: string) => ({type: PARTICIPANT_FETCH_ONE_QUEUE, participantId});
export const fetchOneParticipantSuccess = (participant: Participant) => ({type: PARTICIPANT_FETCH_ONE_SUCCESS, participant});
export const fetchOneParticipantFailure = (id: string, err: any) => {
		console.error('ParticipantAction: fetchOneParticipantFailure', err);
		return {type: PARTICIPANT_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveParticipant = (participant: Participant) => {
    // console.debug('⮂ PARTICIPANT_SAVE action', participant?.id);
    return {type: PARTICIPANT_SAVE, participant};
}
export const saveParticipantQueue = (participant: Participant, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ PARTICIPANT_SAVE_QUEUE action', participant?.id);
    return {type: PARTICIPANT_SAVE_QUEUE, participant, onQueued};
}
export const saveParticipantSuccess = (participant: Participant) => {
    // console.debug('⮂ PARTICIPANT_SAVE_SUCCESS action', participant?.id);
    return {type: PARTICIPANT_SAVE_SUCCESS, participant};
}
export const saveParticipantFailure = (participant: Participant, status: number, message: string) => {
    console.warn(`⮂ PARTICIPANT_SAVE_FAILURE error saving participant: HTTP ${status}: ${message}`, participant?.id);
    return {type: PARTICIPANT_SAVE_FAILURE, participant, status, message};
};

/* SaveMany actions */
export const saveManyParticipants = (participants: Participant[]) => {
    // console.debug('⮂ PARTICIPANT_SAVE_MANY action', participants?.map(participant => participant?.id).join(','));
    return {type: PARTICIPANT_SAVE_MANY, participants};
}
export const saveManyParticipantsQueue = (participants: Participant[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ PARTICIPANT_SAVE_MANY_QUEUE action', participants?.map(participant => participant.id).join(','));
    return {type: PARTICIPANT_SAVE_MANY_QUEUE, participants, onQueued};
}

export const saveManyParticipantsSuccess = (participants: Participant[]) => {
    // console.debug('⮂ PARTICIPANT_SAVE_MANY_SUCCESS action', participants?.map(participant => participant.id).join(','));
    return {type: PARTICIPANT_SAVE_MANY_SUCCESS, participants};
}
export const saveManyParticipantsFailure = (participants: Participant[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_PARTICIPANTS_FAILURE Error saving participants: HTTP ${status}: ${message}`, participants?.map(participant => participant.id).join(','));
		return {type: PARTICIPANT_SAVE_MANY_FAILURE, participants, status, message};
};

/* Remove actions */
export const removeParticipant = (participant: Participant) => ({ type: PARTICIPANT_REMOVE, participant });
export const removeParticipantQueue = (participant: Participant) => ({ type: PARTICIPANT_REMOVE_QUEUE, participant });
export const removeParticipantSuccess = (participant: Participant) => ({ type: PARTICIPANT_REMOVE_SUCCESS, participant });
export const removeParticipantFailure = (participant: Participant, status: number, message: string) => {
	console.error(`Redux: removeParticipantFailure Error removing participant: HTTP ${status}: ${message}`);
	return ({ type: PARTICIPANT_REMOVE_FAILURE, participant, status, message });
};

/* Restore actions */
export const restoreParticipant = (participant: Participant) => ({ type: PARTICIPANT_RESTORE, participant });
export const restoreParticipantQueue = (participant: Participant) => ({ type: PARTICIPANT_RESTORE_QUEUE, participant });
export const restoreParticipantSuccess = (participant: Participant) => ({ type: PARTICIPANT_RESTORE_SUCCESS, participant });
export const restoreParticipantFailure = (participant: Participant, status: number, message: string) => {
	console.error(`Redux: restoreParticipantFailure Error restoring participant: HTTP ${status}: ${message}`);
	return ({ type: PARTICIPANT_RESTORE_FAILURE, participant, status, message });
};

/* RestoreMany actions */
export const restoreManyParticipants = (participants: Participant[]) => ({ type: PARTICIPANT_RESTORE_MANY, participants });

/* RemoveMany actions */
export const removeManyParticipants = (participants: Participant[]) => ({ type: PARTICIPANT_REMOVE_MANY, participants });